export default {
    parse: {
        prelude() {
            return this.createSingleNodeList(
                this.LayerList()
            );
        },
        block() {
            return this.Block(false);
        }
    }
};
